import services from "@/services/service"

class Event {
  _init = async () => {
    return true
  }

  resolve = async (event, data = null) => {
    let _event = {}
    if (!event.type) {
      event = {
        type: event,
        detail: data
      }
    }

    /* Platform-specific Event */
    if (event.type === "media_event") {
      let tempName
      switch (event.detail) {
        case "play":
          tempName = "mediaPlaying"
          this._setVideoSize()
          break
        case "stop":
          tempName = "mediaStopped"
          break
        case "pause":
          tempName = "mediaPaused"
          break
        case "error":
          tempName = "mediaError"
          break
        case "ended":
          tempName = "mediaEnded"
          break
        default:
          return false
      }
      _event.name = tempName
    } else if (event.type === "source_event") {
      _event.name = "source"
      _event.data = event.detail
    } else if (event.type === "power_mode_changed") {
      _event.name = "power"
      _event.data = event.detail
    } else if (event.type === "data_received") {
      let socketData = null
      try {
        if (event.detail.data === "newMessage") return services.action.initAjax(false, true)
        socketData = window.atob(event.detail.data)
        socketData = JSON.parse(socketData)
      } catch (e) {
        return _$.error(e)
      }
      if (socketData.hasOwnProperty("action")) _$.vue.$emit("action", socketData)
      else if (socketData.hasOwnProperty("weather")) _$.vue.$emit("weather", socketData)
      else if (socketData.hasOwnProperty("chromecast")) _$.vue.$emit("chromecast", socketData)
      else if (socketData.hasOwnProperty("rc")) _$.vue.$emit("rc-command", socketData)
      return false
    }
    return _event
  }
  _setVideoSize = async () => {
    const { width, height, x, y, index } = __.common.tvWindowMetrics
    return __._common.setTvWindowSize({ width, height, x, y, index }, true).catch(err => _$.error(err))
  }
}

export default Event
